module.exports = __webpack_public_path__ + "static/images/icon-phone.a447244aeb2f5978efe7613a88921124.svg";